import $api from '../api/index';

const state = {
  byDealId: {}
};

const getters = {
  isFavorite: state => (dealId, venueId) => {
    const favorites = state.byDealId[dealId];
    return Array.isArray(favorites) && favorites.includes(venueId);
  },

  getFavorites: state => dealId => {
    return state.byDealId[dealId] || [];
  },

  hasFavorites: state => dealId => {
    const favorites = state.byDealId[dealId];
    return Array.isArray(favorites) && favorites.length > 0;
  }
};

function getPartnerUserId(rootState) {
  return rootState?.partnerUser?.id || null;
}

const actions = {
  setFavorites({ commit }, byDealId) {
    commit('setFavorites', byDealId || {});
  },

  async toggleFavorite({ dispatch, getters }, { dealId, venueId }) {
    if (getters.isFavorite(dealId, venueId)) {
      await dispatch('removeFavorite', { dealId, venueId });
    } else {
      await dispatch('addFavorite', { dealId, venueId });
    }
  },

  async addFavorite({ commit, getters, rootState }, { dealId, venueId }) {
    const partnerUserId = getPartnerUserId(rootState);
    if (!partnerUserId) return;
    if (getters.isFavorite(dealId, venueId)) return;

    commit('addFavorite', { dealId, venueId });
    try {
      await $api.favorites.add(partnerUserId, dealId, venueId);
    } catch (err) {
      commit('removeFavorite', { dealId, venueId });
      throw err;
    }
  },

  async removeFavorite({ commit, getters, rootState }, { dealId, venueId }) {
    const partnerUserId = getPartnerUserId(rootState);
    if (!partnerUserId) return;
    if (!getters.isFavorite(dealId, venueId)) return;

    commit('removeFavorite', { dealId, venueId });
    try {
      await $api.favorites.remove(partnerUserId, dealId, venueId);
    } catch (err) {
      commit('addFavorite', { dealId, venueId });
      throw err;
    }
  }
};

const mutations = {
  setFavorites(state, byDealId) {
    const normalized = {};
    Object.keys(byDealId || {}).forEach(dealId => {
      const ids = byDealId[dealId];
      if (Array.isArray(ids)) {
        normalized[dealId] = ids.map(id => Number(id));
      }
    });
    state.byDealId = normalized;
  },

  addFavorite(state, { dealId, venueId }) {
    const id = Number(venueId);
    if (!state.byDealId[dealId]) {
      state.byDealId = { ...state.byDealId, [dealId]: [id] };
    } else if (!state.byDealId[dealId].includes(id)) {
      state.byDealId[dealId] = [...state.byDealId[dealId], id];
    }
  },

  removeFavorite(state, { dealId, venueId }) {
    const id = Number(venueId);
    if (state.byDealId[dealId]) {
      state.byDealId[dealId] = state.byDealId[dealId].filter(v => v !== id);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
